module.exports = __webpack_public_path__ + "img/truck-time(1).7d9fe18d.svg";